module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-Thin.woff2?c51873c62e5cf935f028cdf0e24529eb";